export enum WhatsNewCardType {
    Free = 'Free',
    Premium = 'Premium',
    NonPremium = 'NonPremium',
}
